import ApplicationForm from './ApplicationForm';
import './ApplicationModal.css';

const ApplicationModal = ({ job, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">

        <button
          className="close-btn"
          onClick={onClose}
        >
          ✕
        </button>

        <ApplicationForm
            selectedPosition={job.title}
            onSuccess={onClose}
        />
      </div>
    </div>
  );
};

export default ApplicationModal;